export default __webpack_public_path__ + "static/media/ico-arrow-down.03c4000a.svg";